import { PillProps } from './Pill.types';

const getVariantClasses = (variant: string) => {
  switch (variant) {
    case 'completed':
      return 'bg-cyan-100 text-cyan-700';
    case 'in-progress':
      return 'bg-purple-100 text-purple-700';
    case 'not-started':
      return 'bg-gray-100 text-gray-800';
    case 'success':
      return 'bg-green-50 text-green-700';
    case 'warning':
      return 'bg-yellow-50 text-yellow-700';
    case 'error':
      return 'bg-red-50 text-red-700';
    case 'info':
      return 'bg-blue-50 text-blue-700';
    case 'neutral':
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export function Pill({ children, variant = 'neutral', className = '' }: PillProps) {
  const variantClasses = getVariantClasses(variant);

  return (
    <span
      className={`px-[10px] py-[2px] rounded-full text-xs font-medium whitespace-nowrap ${variantClasses} ${className}`}
    >
      {children}
    </span>
  );
}

